import React from "react";
import Card from "components/Card";
import { FormattedMessage } from "react-intl";
import { useAuth, useConnections } from "hooks";
import { CONNECTION_TYPES } from "constants/index";
import { Header } from "components/DisplayBox";
import { H3 } from "components/Text";
import CalendlyIntegration from "./CalendlyIntegration";
import CalendlySchedulingSettings from "./CalendlySchedulingSettings";
import { Grid } from "components/Containers";

/**
 * InterviewScheduling
 */
const InterviewScheduling = () => {
  const { isClient } = useAuth();

  const { connections, loading } = useConnections({
    filters: { types: [CONNECTION_TYPES.calendly] },
  });

  const calendlyConnection = connections?.find((connection) => connection.type === CONNECTION_TYPES.calendly);

  return (
    <>
      <Grid>
        <Grid.col start={1} end={13}>
          <Card>
            <Header noUnderline>
              <H3>
                <FormattedMessage id="UserSettings.InterviewScheduling.Title" />
              </H3>

              {isClient && <FormattedMessage id="UserSettings.InterviewScheduling.Description" />}
            </Header>

            <CalendlyIntegration connection={calendlyConnection} loading={loading} />
          </Card>
        </Grid.col>

        {!loading && (
          <Grid.col start={1} end={13}>
            <Card>
              <Header noUnderline>
                <H3>
                  <FormattedMessage id="UserSettings.InterviewScheduling.SchedulingTitle" />
                </H3>
                <FormattedMessage
                  id={
                    calendlyConnection?.enabled
                      ? "UserSettings.InterviewScheduling.SchedulingDescription"
                      : "UserSettings.InterviewScheduling.SchedulingConnectFirst"
                  }
                />
              </Header>

              <CalendlySchedulingSettings
                key={String(!!calendlyConnection?.enabled)}
                preview={!calendlyConnection?.enabled}
              />
            </Card>
          </Grid.col>
        )}
      </Grid>
    </>
  );
};

export default InterviewScheduling;
